<template>
  <div>
    <div class="icon-picker" :class="{ 'disabled-input': disabled }">
      <SvgIcon :icon="{}" v-if="!tempIcon" @click="showPicker"></SvgIcon>
      <SvgIcon :icon="tempIcon" v-if="tempIcon" @click="showPicker"></SvgIcon>
      <v-icon
        class="remove-icon"
        x-small
        color="red"
        v-if="tempIcon"
        @click="removeIcon()"
        >mdi-close</v-icon
      >
      <v-menu
        :position-x="x"
        :position-y="y"
        absolute
        :close-on-content-click="false"
        :close-on-click="true"
        v-model="visible"
        width="300px"
      >
        <v-card>
          <div class="d-flex">
            <v-btn
              text
              small
              :color="selectedMode === 'ABSTRACT' ? 'primary' : ''"
              @click="selectedMode = 'ABSTRACT'"
              >Abstract</v-btn
            >
            <v-btn
              text
              small
              :color="selectedMode === 'SOCIAL' ? 'primary' : ''"
              @click="selectedMode = 'SOCIAL'"
              >Social</v-btn
            >
            <v-btn
              text
              small
              :color="selectedMode === 'COLOR' ? 'primary' : ''"
              @click="selectedMode = 'COLOR'"
              >Colored</v-btn
            >
            <v-spacer></v-spacer>
            <v-icon small @click="visible = false" class="mr-2"
              >mdi-close</v-icon
            >
          </div>
          <v-divider></v-divider>
          <IconPickerAbstract
            @input="onPick($event)"
            :svgs="getIconPack()"
          ></IconPickerAbstract>
        </v-card>
        <div></div>
      </v-menu>
    </div>
    <SliderInput
      v-if="tempIcon"
      label="Size"
      :sliderValue="tempIcon.size"
      min="40"
      max="60"
      @change="
        $emit('input', {
          ...tempIcon,
          size: $event,
        })
      "
    />
    <v-switch
      thumb-label
      label="Transparent?"
      dense
      min="10"
      max="40"
      v-model="tempIcon.transparent"
      v-if="tempIcon"
      @change="$emit('input', tempIcon)"
      class="mt-2"
      step="2"
      flat
      inset
    ></v-switch>
  </div>
</template>

<script>
import IconPickerAbstract from "./IconPickerAbstract";
import SliderInput from "./SliderInput";
import SvgIcon from "./SvgIcon";
import { icons } from "landly-uiblocks";

export default {
  components: {
    IconPickerAbstract,
    SvgIcon,
    SliderInput,
  },
  data() {
    return {
      icons,
      visible: false,
      x: 0,
      y: 0,
      tempIcon: null,
      selectedMode: "ABSTRACT", // ABSTRACT | SOCIAL | COLOR
    };
  },
  props: ["icon", "disabled"],
  methods: {
    showPicker(e) {
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    removeIcon() {
      this.tempIcon.svg = null;
      this.tempIcon = null;
      this.$emit("input", this.tempIcon);
    },
    onPick($event) {
      if (!this.tempIcon) {
        this.tempIcon = {
          shape: "circle",
          transparent: false,
          size: 20,
        };
      }
      this.tempIcon.svg = $event.svg;
      this.$emit("input", JSON.parse(JSON.stringify(this.tempIcon)));
    },
    getIconPack() {
      if (this.selectedMode === "ABSTRACT") return icons.abstract();
      if (this.selectedMode === "SOCIAL") return icons.social();
      if (this.selectedMode === "COLOR") return icons.color();
    },
  },
  created() {
    this.tempIcon = JSON.parse(JSON.stringify(this.icon));
  },
};
</script>

<style scoped>
.icon-picker {
  position: relative;
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}
.remove-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
  background-color: white;
}
</style>